// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — ConfirmWithComment.styled.classic.js, новая — ConfirmWithComment.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './ConfirmWithComment.styled.classic';
import * as cp from './ConfirmWithComment.styled.cp';

export const Block = isCp ? cp.Block : classic.Block;
export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
export const Fields = isCp ? cp.Fields : classic.Fields;
export const Title = isCp ? cp.Title : classic.Title;
export const WarningContainer = isCp ? cp.WarningContainer : classic.WarningContainer;
